import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, FormField, FormGrid, Page } from '@dixa/lib-shared-habla';
import { formValueSelector, reduxForm } from 'redux-form';
import { useBreakpointValue } from 'utils/mediaQuery';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { GeneralSettings } from './components/generalSettings/generalSettings';
import { LastAgentSettings } from './components/lastAgentSettings/lastAgentSettings';
import { OfferSettings } from './components/offerSettings/offerSettings';
import { PreferredAgentSettings } from './components/preferredAgentSettings/preferredAgentSettings';
import { validateQueuesSettingsForm } from './utils/validateQueueSettingsForm';
const formFields = [
    'name',
    'priority',
    'is_default',
    'is_archived',
    'offer_timeout',
    'wrapup_timeout',
    'offer_algorithm',
    'is_do_not_offer_enabled',
    'offer_abandoned_conversations',
    'is_preferred_agent_enabled',
    'is_personal_offer_prioritized',
    'do_not_offer_timeouts',
    'preferred_agent_timeouts',
    'preferred_agent_offline_timeout_enabled',
    'preferred_agent_offline_timeout',
    'personal_agent_offline_timeout_enabled',
    'personal_agent_offline_timeout',
];
const queuesSettingsForm = 'queuesSettingsForm';
function QueuesSettingsFormImpl({ pristine, submitting, handleSubmit, mode, isLoading, }) {
    const formValues = useAppSelector((state) => formValueSelector(queuesSettingsForm)(state, ...formFields));
    const isMediumScreen = useBreakpointValue({ base: true, lg: false });
    const span = isMediumScreen ? 6 : 4;
    return (_jsx("form", Object.assign({ onSubmit: handleSubmit, id: "queue-settings-form" }, { children: _jsx(Page.Section, Object.assign({ title: "General", controls: _jsx(Button, Object.assign({ disabled: pristine || submitting || isLoading, isLoading: isLoading, type: "submit" }, { children: mode === 'edit' ? 'Save changes' : 'Create queue' })) }, { children: _jsxs(FormGrid, { children: [_jsx(FormField, Object.assign({ span: span }, { children: _jsx(GeneralSettings, { formValues: formValues }) })), _jsx(FormField, Object.assign({ span: span }, { children: _jsx(OfferSettings, { formValues: formValues }) })), _jsx(FormField, Object.assign({ span: span }, { children: _jsx(LastAgentSettings, { formValues: formValues }) })), _jsx(FormField, Object.assign({ span: span }, { children: _jsx(PreferredAgentSettings, { formValues: formValues }) }))] }) })) })));
}
export const QueuesSettingsForm = reduxForm({
    form: queuesSettingsForm,
    enableReinitialize: true,
    validate: validateQueuesSettingsForm,
})(QueuesSettingsFormImpl);
